@if(!field()){
<code>...Loading</code>
}
@else{
  @if(field().renderType.type==='time'){
<label [for]="field().fieldId.toString()">{{ label }}</label>
  <mat-form-field>    
    <input matInput
           [id]="field().fieldId.toString()"
           [matTimepicker]="picker"
           [formControl]="formControl"
           (click)="picker.open()">
    <mat-timepicker-toggle matIconSuffix [for]="picker" />
    <mat-timepicker #picker />
    @if(formControl.errors?.['required']){
    <mat-error>{{ label }} is <strong>required</strong></mat-error>
    }
  </mat-form-field>
  }
  @else{
  <label [for]="field().fieldId.toString()">{{ label }}</label>
  <mat-form-field>    
    <input matInput
           [matDatepicker]="picker"
           [id]="field().fieldId.toString()"
           [placeholder]="label!"
           [formControl]="formControl"
           (click)="picker.open()">
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    @if(formControl.errors?.['required']){
    <mat-error>{{ label }} is <strong>required</strong></mat-error>
    }
  </mat-form-field>
  }
}

